#import "../fragments/account-hierarchy-info-fragment.graphql"

query GetAccountHierarchyWidget($id: ID!) {
    account(id: $id) {
        ...AccountHierarchyInfoFragment
    }
}
